module.exports = __webpack_public_path__ + "img/lt.a14940a6.svg";